import React from "react";
import {
  Box,
  Image,
  Text,
  Heading,
  Switch,
  VStack,
  IconButton,
  Spacer,
  Badge,
  HStack,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import { FaHeart, FaPen } from "react-icons/fa";
import Translate from "../../components/LanguageTranslation/Translate";
import countries from "i18n-iso-countries";

const countryFlagLink = (countryName) => {
  const countryCode = countryName
    ? countries.getAlpha2Code(countryName, "en")
    : null;
  if (!countryCode) {
    return "../assets/images/banner.jpg";
  }
  return `https://flagcdn.com/w320/${countryCode.toLowerCase()}.png`;
};

const ItineraryCard = ({
  itinerary,
  status,
  tripId, // Receive the trip ID
  onToggleOngoingTrip,
  ongoingTrip,
  handleDelete,
}) => {
  // console.log("status", status);
  const history = useHistory();

  const title = itinerary?.itinerary.trip_name || "Untitled Trip";
  const mainImage =
    itinerary?.destinations?.[0]?.trip_plan?.itinerary?.[0]
      ?.activity_detail_list?.[0]?.images?.[0]?.variants?.[2]?.url ||
    countryFlagLink(itinerary?.destinations?.[0]?.country);

  const handleCardClick = () => {
    if (ongoingTrip && ongoingTrip._id === tripId) {
      history.push(`/ai-travel-planner/ongoing-trip`);
    } else {
      history.push(`/ai-travel-planner/manage-itinerary/${tripId}`); // Navigate to the specific itinerary page using trip ID
    }
  };

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      cursor="pointer" // Make every card clickable
      onClick={handleCardClick} // Handle click to navigate to the itinerary page
    >
      <Box position="relative">
        <Image
          src={mainImage}
          fallbackSrc={countryFlagLink(itinerary?.destinations?.[0]?.country)}
          alt={title}
          width="100%"
          height="30vh"
          objectFit="cover"
        />
        <IconButton
          aria-label="Add to favorites"
          icon={<FaHeart />}
          size="md"
          bg="none"
          _hover={{ bg: "none" }}
          position="absolute"
          top="3px"
          right="3px"
          borderRadius="full"
          color="red.500"
          onClick={handleDelete}
        />
      </Box>
      <Box p="6">
        <HStack>
          <Heading display="flex" size="sm" mb="0" noOfLines={1}>
            <Translate text={title} />
          </Heading>
          <Spacer />
          <Box ml={2} mb={2}>
            <FaPen />
          </Box>
          <Badge
            bg="none"
            color="#286328"
            border="1px solid"
            borderColor="#286328"
            borderRadius="md"
            textTransform="capitalize"
            fontSize="xs"
            fontWeight="bold"
            mb={2}
          >
            <Translate text={status || "Unknown"} />
          </Badge>
        </HStack>
        <VStack align="start" spacing={2} w="100%">
          <Box display="flex" onClick={(e) => e.stopPropagation()} w="100%">
            <Text mb={0} mr={2} fontSize="sm">
              <Translate text="Ongoing Trip" />
            </Text>
            <Switch
              mt={1}
              size="sm"
              isChecked={ongoingTrip ? ongoingTrip._id === tripId : false}
              onChange={onToggleOngoingTrip}
              colorScheme="customGreen"
            />
            <Spacer />
          </Box>
        </VStack>
      </Box>
    </Box>
  );
};

export default ItineraryCard;
